export const styles = theme => ({
    inputField: {
        "& input": {
            fontSize: "0.85rem",
            border: "1px solid #C4C4C4",
            height: 47,
        },
        "& label": {
            fontSize: "0.85rem",
            color: "#AFAFAF"
        },
        "& div:before": {
            border: 0
        }
    },
    multilineField: {
        background: "white",
        border: "1px solid #C4C4C4",
        "& input": {
            fontSize: "0.85rem",
            height: 47,
        },
        "& label": {
            fontSize: "0.85rem",
            color: "#AFAFAF"
        },
        "& div:before": {
            border: 0,
        },
        "& div": {
            background: "white !important",
        }
    }
});
